import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  alpha,
} from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '@/context/AuthContext';

interface LoginModalProps {
  open: boolean;
  onClose: () => void;
}

export default function LoginModal({ open, onClose }: LoginModalProps) {
  const { signInWithGoogle } = useAuth();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: alpha('#131920', 0.95),
          backgroundImage: 'none',
          borderRadius: 2,
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'text.secondary',
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ p: 4, textAlign: 'center' }}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            fontWeight: 700,
            background: 'linear-gradient(135deg, #00D4AA 0%, #008866 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          AlphaMoeMoe
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          登录以查看每日博主笔记
        </Typography>

        <Button
          variant="contained"
          size="large"
          startIcon={<GoogleIcon />}
          onClick={signInWithGoogle}
          sx={{
            bgcolor: '#fff',
            color: '#333',
            '&:hover': {
              bgcolor: '#f5f5f5',
            },
          }}
        >
          Sign in with Google
        </Button>
      </DialogContent>
    </Dialog>
  );
}
